import { render } from "./TopPodcasts.vue?vue&type=template&id=44107944&ts=true"
import script from "./TopPodcasts.vue?vue&type=script&lang=ts"
export * from "./TopPodcasts.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__